import {createReactQueryHooks} from "@trpc/react"
import type {AppRouter} from "custom-app-router"

export const trpc = createReactQueryHooks<AppRouter>()
